import { UIText2 } from '@cian/ui-kit';

import * as styles from './Agent.css';

export interface IAgentProps {
  agentName?: string;
  cianUserId?: number;
  isByHomeowner?: boolean;
  url?: string;
}

export function Agent({ agentName, cianUserId, isByHomeowner, url }: IAgentProps) {
  return (
    <div className={styles['container']}>
      <noindex>
        {url ? (
          <a href={url} className={styles['link']} target="_blank" rel="noreferrer">
            <UIText2>{`ID:${cianUserId}` || agentName}</UIText2>
          </a>
        ) : (
          <UIText2>{`ID:${cianUserId}` || agentName}</UIText2>
        )}
      </noindex>
      {isByHomeowner && <UIText2>Собственник</UIText2>}
    </div>
  );
}
